import { Box, Chip, Avatar, Typography, Tooltip, CircularProgress } from "@mui/material";
import React, { useEffect, useContext, useState } from "react";
import { apps } from "../../data/data";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API } from "../../controller/api";
import { LanguageContext } from "../../controller/context/languageContext";
import { TitleContext } from "../../controller/context/TitleContext";
import { v4 as uuidv4 } from 'uuid';
import { SearchBar } from "../SearchBar";
import { DrawerContext } from "../../controller/context/DrawerWidthContext"; 
import { general } from "../../data/generalData";
import { writers } from "../../data/WriterData";
import { useTheme } from "@emotion/react";
import { ThemeContext } from "../../controller/context/ThemeContext";
import RectangularChip from "./components/RectangularChip";
import RectangularChipBots from "./components/RectangularChipBots";
import { Add, Assistant, Info, InfoRounded } from "@mui/icons-material";
import CustomChatAssistantModal from "./components/CustomChatAssistantModal";
import Cookies from 'js-cookie';
import RectangularChipCustomBots from "./components/RectangularChipCustomBots";
import EditCustomChatAssistantModal from "./components/EditCustomChatAssistantModal";
import LoadingModal from "./components/LoadingModal";
import { useTranslateButton } from "../../controller/context/TranslateButtonContext";

export const Hub = () => {
  const { themeMode, toggleTheme } = useContext(ThemeContext);
  const user = JSON.parse(Cookies.get('user'));
          const userId = user.id;
  const[deleting, setDeleting] = useState(false)
  const theme = useTheme();
  const { setTitle } = useContext(TitleContext);
  const { language } = useContext(LanguageContext);
  const { drawerWidth } = useContext(DrawerContext); 
  const [translating, setTranslating] = useState(false);
  const [translationMap, setTranslationMap] = useState({});
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('All'); // State for selected category
  const[customChatModal, seCustomChatModal] = useState(false);
  const[customChatEditModal, seCustomChatEditModal] = useState(false);
const [update, setUpdate] = useState(false)
const { showTranslateButton, setShowTranslateButton } = useTranslateButton(); // Access the context

const [editData, setEditData] = useState(null)
const [customBots, setCustomBots] = useState([])
  const fetchUserData = async () => {
    const token = Cookies.get('token');
    try {
      const response = await axios.post(`${API}/auth/refresh-user`, { token });
      Cookies.set('userId', response.data.user.id, { expires: 7, secure: true, sameSite: 'Strict' });
      setCustomBots(response.data.user.customBots);
      console.log(response.data.user)
      setDeleting(false)

    } catch (error) {
      console.error('Error fetching user data:', error);
      setDeleting(false)

    }
  };

  useEffect(() => {
    setShowTranslateButton(true)
    fetchUserData();
  }, [update]);

  const handleCloseModal = ()=>{
    seCustomChatModal(false);
  }

  const handleOpenModal = ()=>{
    seCustomChatModal(true);
  }

  const handleCloseEditModal = ()=>{
    seCustomChatEditModal(false);
  }

  const handleOpenEditModal = ()=>{
    seCustomChatEditModal(true);
  }
  const groupAppsByCategory = (apps) => {
    return apps.reduce((acc, app) => {
      app.category.forEach((cat) => {
        acc[cat] = acc[cat] || [];
        acc[cat].push(app);
      });
      return acc;
    }, {});
  };

  useEffect(() => {
    
    const fetchTranslatedAppNames = async () => {
      if (language === 'en') {
        // Reset translationMap to default English values
        const map = {};
    
        // Map app and general names
        [...apps, ...general].forEach((app) => {
          map[app.appName] = app.appName;
        });
    
        // Map category names
        const categoryNames = Array.from(new Set(apps.flatMap(app => app.category)));
        categoryNames.forEach((cat) => {
          map[cat] = cat;
        });
    
        // Map heading names
        const headingNames = [
          'Official GPT Models',
          'Applications',
          'HR Chat Assistants',
          'All',
          'Custom Chat Assistants'
        ];
        headingNames.forEach((heading) => {
          map[heading] = heading;
        });
    
        setTranslationMap(map);
      } else {
        // Translate for non-English language
        setTranslating(true);
        try {
          const appNames = apps.map(app => app.appName);
          const generalNames = general.map(app => app.appName);
          const categoryNames = Array.from(new Set(apps.flatMap(app => app.category)));
    
          const headingNames = [
            'Official GPT Models',
            'Applications',
            'HR Chat Assistants',
            'All',
            'Custom Chat Assistants'
          ];
    
          const allNames = [...appNames, ...generalNames, ...categoryNames, ...headingNames];
    
          const translatedNames = await translateAppNames(allNames, language);
    
          const map = {};
    
          // Map app and general names
          [...apps, ...general].forEach((app, index) => {
            map[app.appName] = translatedNames[index];
          });
    
          // Map category names
          categoryNames.forEach((cat, index) => {
            map[cat] = translatedNames[appNames.length + generalNames.length + index];
          });
    
          // Map heading names
          headingNames.forEach((heading, index) => {
            map[heading] = translatedNames[
              appNames.length + generalNames.length + categoryNames.length + index
            ];
          });
    
          setTranslationMap(map);
        } catch (error) {
          console.error('Error fetching translated app names:', error);
        } finally {
          setTranslating(false);
        }
      }
    };
    
    
    
    fetchTranslatedAppNames();
  }, [language]);

  useEffect(() => {
    console.log('Translation Map:', translationMap);
  }, [translationMap]);
  

  const translateAppNames = async (appNames, targetLanguage) => {
    try {
      const response = await axios.post(`${API}/chat/translateAppNames`, {
        appNames,
        targetLanguage,
      });
      return response.data;
    } catch (error) {
      console.error('Error translating app names:', error);
      throw error;
    }
  };

  const navigate = useNavigate();

  if (translating) {
    return (<Box justifyContent="center" textAlign='center' padding={10}><Typography>Translating</Typography> <CircularProgress/></Box>);
  } else {
    // Filter apps based on selected category and search term
    const filteredApps = apps.filter(app =>
      app.appName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      app.category.some(cat => cat.toLowerCase().includes(searchTerm.toLowerCase()))
    );

    const filteredGroupedApps = groupAppsByCategory(filteredApps);

    // Get unique categories from all apps
    const allCategories = Array.from(new Set(apps.flatMap(app => app.category)));

    const handleCategoryClick = (category) => {
      setSelectedCategory(category);
    };

    // Filter apps based on selected category
    const displayedApps = selectedCategory === 'All'
      ? filteredApps
      : filteredApps.filter(app => app.category.includes(selectedCategory));

    return (
      <Box sx={{ 
        padding: 2,
        paddingBottom: 10,
        marginTop: 6,
        paddingTop:4,
        maxHeight: '100vh',
        overflowY: 'auto',
        textAlign: 'left',
        paddingLeft: { xs: drawerWidth === 0 ? 40 : 0, sm:  drawerWidth === 0 ? 40: 0 },
        paddingRight: { xs: 0, sm: 0 },
      }}>

<Typography sx={{ fontSize: 20, marginLeft: 2 }}>
  <b>{translationMap['Official GPT Models'] || 'Official GPT Models'}</b>
</Typography>

<Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, marginBottom: 2, marginTop: 2, paddingLeft: 4, paddingRight: 4 }}>
  {general.map((o) => (
    <RectangularChip 
      themeMode={themeMode} 
      key={o.appName} 
      icon={o.avatar} 
      caption={o.description} 
      title={translationMap[o.appName] || o.appName}
      onClick={() => {
        setTitle(o.appName);
        const chatData = {
          appName: o.appName,
          description: o.description,
          entryMessage: o.entryMessage,
          initialPrompt: o.initialPrompt,
          chatId: uuidv4(),
          route: o.route
        };
        navigate('/chat', { state: chatData });
      }}
    />
  ))}
</Box>


      <Typography sx={{ fontSize: 20, marginLeft: 2 }}>
        <b>{translationMap['Applications'] || 'Applications'}</b>      <Tooltip  title={<Typography variant='caption'>Cannot be Translated to another language.</Typography>}><InfoRounded sx={{width:20, cursor:'pointer'}} htmlColor="dodgerBlue"/></Tooltip>

      </Typography>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 , marginBottom:2, marginTop:2, paddingLeft:4, paddingRight:4}}>
          {writers.map((i, index) => (
           <RectangularChip 
           themeMode={themeMode} 
           icon={<img style={{ width: 60, height: 40 }} 
           src={i.avatar} alt={i.appName} />} 
           caption={i.description} 
           title={i.appName} 
           onClick={() => {
            setTitle(i.appName);
            navigate(i.route === 'NA' ? '' : '/dc', { state: i });
          }}
           />
          ))}
        </Box>

        <Typography sx={{ fontSize: 20, marginLeft: 2 }}>
        <b>{translationMap['Custom Chat Assistants'] || 'Custom Chat Assistants'}</b>
      </Typography>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 , marginBottom:2, marginTop:2, paddingLeft:4, paddingRight:4}}>
      
          {customBots.map((i, index) => (
           <RectangularChipCustomBots 
           key={index}
           themeMode={themeMode} 
          //  icon={<Hub/>} 
           title={i.appName} 
           onClick={() => {
            setTitle(i.appName);
            const chatData = {
              appName: i.appName,
          
              entryMessage: i.entryMessage,
              initialPrompt: i.initialPrompt,
              chatId: uuidv4(),
              route: i.route,
              documentChunks : i.documentChunks.length > 0 ? i.documentChunks :[]
            };
            navigate('/chat', { state: chatData });
          }}
          onEdit={()=>{
            console.log(i)
            setEditData(i);
            handleOpenEditModal();
          }}

          onDelete={async()=>{
            setDeleting(true)
            const response = await axios.post(`${API}/custom-bots/delete-bot`,{userId, botId:i.id});

            if(response.data.message === 'Success'){
        
          
              window.alert('Your bot has successfully deleted.')
              setUpdate(!update)

            } else {
        
          
              window.alert('Something went wrong. Please try again or contact support.')
          
            }
          }}
           />
           
          ))}

          <RectangularChip 
           icon={<Add/>} 
           themeMode={themeMode} 
           title="Create Custom Chat Assistant" 
           onClick={handleOpenModal}
           />
        </Box>
        <Typography sx={{ fontSize: 20, marginLeft: 2 }}>
        <b>{translationMap['HR Chat Assistants'] || 'HR Chat Assistants'}</b>
      </Typography>

        <SearchBar
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />

        {/* Category Chips */}
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, marginBottom: 2, marginLeft: 2 }}>
          <Chip
            label={translationMap['All'] || 'All'}
            onClick={() => handleCategoryClick('All')}
            variant={selectedCategory === 'All' ? 'filled' : 'outlined'}
            color={selectedCategory === 'All' ? 'primary' : 'default'}
          />
          {allCategories.sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }))
          .map((category) => (
            <Chip
              key={category}
              label={translationMap[category] || category}
              onClick={() => handleCategoryClick(category)}
              variant={selectedCategory === category ? 'filled' : 'outlined'}
              color={selectedCategory === category ? 'primary' : 'default'}
            />
          ))}
        </Box>

        {/* Displaying apps by selected category */}
        <Typography sx={{ fontSize: 20, marginTop:2, marginBottom:2, marginLeft:2 }}><b>{selectedCategory}</b></Typography>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, marginBottom: 2, marginTop: 2, paddingLeft:4, paddingRight:4 }}>

          {displayedApps.sort((a, b) => a.appName.localeCompare(b.appName, undefined, { sensitivity: 'base' }))
          .map((app) => (
         <RectangularChipBots
         themeMode={themeMode} 
         onClick={() => {
          setTitle(app.appName);
          const chatData = {
            appName: app.appName,
            description: app.description,
            entryMessage: app.entryMessage,
            initialPrompt: app.initialPrompt,
            chatId: uuidv4(),
            route: app.route
          };
          navigate('/chat', { state: chatData });
        }}
         icon={app.avatar} 
        caption={app.description} 
        title={translationMap[app.appName] || app.appName}  
        />
          ))}

        </Box>
        <CustomChatAssistantModal 
        open={customChatModal}
        handleClose={handleCloseModal}
        setUpdate={setUpdate}
        update={update}
        />
        <EditCustomChatAssistantModal
        data={editData}
        open={customChatEditModal}
        handleClose={handleCloseEditModal}
        setFormData={setEditData}
        setUpdate={setUpdate}
        update={update}
        />

        <LoadingModal Title="Deleting Assistant" Open={deleting}/>
      </Box>
    );
  }
};
